/*
  Classic no longer sells plan upgrades. Every upsell surface points at the new
  DealMachine instead (BYE-126). Web has a matching pair of helpers in
  app/NativeComponents/components/NewDealMachineBanner for the migration banners --
  that file is web only, so the UTM shape is mirrored here for the shared panel.
*/

const NEW_DEALMACHINE_SIGN_IN_URL = "https://dealmachine.com/sign-in";
const NEW_DEALMACHINE_GUIDE_URL =
  "https://dealmachine.com/guides/classic-account";

const buildUrl = (base, params) => {
  const query = Object.keys(params)
    .filter(key => !!params[key])
    .map(
      key => encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
    )
    .join("&");

  return query ? base + "?" + query : base;
};

const migrationParams = (utm_content, feature_slug) => ({
  source: "classic",
  utm_source: "dealmachine_classic",
  utm_medium: "product",
  utm_campaign: "new_dealmachine_migration",
  utm_content,
  //which lock sent them here, so we can see what classic users still try to buy
  utm_term: feature_slug
});

export const getNewDealMachineUpgradeUrl = feature_slug =>
  buildUrl(
    NEW_DEALMACHINE_SIGN_IN_URL,
    migrationParams("upsell_panel_upgrade", feature_slug)
  );

export const getNewDealMachineUpgradeGuideUrl = feature_slug =>
  buildUrl(
    NEW_DEALMACHINE_GUIDE_URL,
    migrationParams("upsell_panel_guide", feature_slug)
  );
